import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import { Link } from "react-router-dom";
import MedicalProfile from "./MedicalProfile";
import InjuryProfile from "./InjuryProfile";
import * as api from "../../common/athleteCommon/API";
import Utils from "../../common/athleteCommon/Utils";
import Swal from "sweetalert2";
import SurgeryProfile from "./SurgeryProfile";
import PhysiologicalProfile from "./PhysiologicalProfile";
import BasicMedicalProfile from "./BasicMedicalProfile";

const OnboardingTabs = () => {

    const [activeTab, setActiveTab] = useState("Basic Profile");
    const [openModal, setOpenModal] = useState(false);
    const [formData, setFormData] = useState({
        medicalCondition: "", relevantFamilyMedicalHistory: "", bloodGroup: "", allergiesDescription: "", allergies: "", currentMedication: "", tobaccoUsageHistory: "", alcoholHistory: "", procced: "", noHistory: "",
        injuryType: "", injuryDescription: "", dateOfInjury: "", dateOfReturnToSports: "", summaryOfTreatment: "", summaryOfRecoveryProcess: "", regionAffected: "", diagnosis: "", injurySeverity: "", mechanismOfInjury: "", injuryManagementApproach: "", timeLostFromTraining_Competition: "",
        dateOfSurgery: "", category: "", bodyRegion: "", procedureSummary: "", complicationsIfAny: "", rehabilitationDuration: "", physiological: ""
    });

    const onboardstep = localStorage.getItem("onboardStep");
    const formRef = useRef(null);


    useEffect(() => {
        if (onboardstep != "6") {
            setOpenModal(true)
            if (onboardstep === "1") {
                setActiveTab("Basic Profile");
            } else if (onboardstep === "2") {
                setActiveTab("Medical Profile");
            } else if (onboardstep === "3") {
                setActiveTab("Injury Profile");
            } else if (onboardstep === "4") {
                setActiveTab("Surgery Profile"); // Default: Personal
            } else if (onboardstep === "5") {
                setActiveTab("Physiological Profile")
            }
        }
    }, [])

    // Keep all fields controlled
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const tabData = [
        {
            icon: <i className="fas fa-user" />,
            name: "Basic Profile",
            content: <BasicMedicalProfile formData={formData} onChange={handleChange} />
        },
        {
            icon: <i className="fas fa-user" />,
            name: "Medical Profile",
            content: <MedicalProfile formData={formData} onChange={handleChange} />
        },
        {
            icon: <i className="fas fa-id-card" />,
            name: "Injury Profile",
            content: <InjuryProfile formData={formData} onChange={handleChange} />
        },
        {
            icon: <i className="fas fa-futbol" />,
            name: "Surgery Profile",
            content: <SurgeryProfile formData={formData} onChange={handleChange} />
        },
        {
            icon: <i className="fas fa-futbol" />,
            name: "Physiological Profile",
            content: <PhysiologicalProfile formData={formData} onChange={handleChange} />
        },
    ]

    const handleSave = (e) => {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (activeTab === "Basic Profile") {
                saveBasicMedicalInfo();
            }
            else if (activeTab === "Medical Profile") {
                saveMedicalInfo();
            }
            else if (activeTab === "Injury Profile") {
                saveInjuryInfo();
            }
            else if (activeTab === "Surgery Profile") {
                saveSurgeryInfo();
            }
            else if (activeTab === "Physiological Profile") {
                savePhysiologicalInfo();
            }
        }
    };

    const handleProceed = (e) => {
        e.preventDefault();
        if (activeTab === "Basic Profile") {
            proceedBasicMedicalInfo();
        }
        else if (activeTab === "Medical Profile") {
            proceedMedicalInfo();
        }
        else if (activeTab === "Injury Profile") {
            proceedInjuryInfo();
        }
        else if (activeTab === "Surgery Profile") {
            proceedSurgeryInfo();
        }
    }

    function saveBasicMedicalInfo() {
        const frmData = new FormData();
        frmData.append("relevantFamilyMedicalHistory", formData.relevantFamilyMedicalHistory);
        frmData.append("bloodGroup", formData.bloodGroup);
        frmData.append("tobaccoUsageHistory", formData.tobaccoUsageHistory);
        frmData.append("alcoholHistory", formData.alcoholHistory);
        const injHstry = api.OnboardBasicMedicalHistory;
        fetch(injHstry, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: frmData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                    // .then((res) => {
                    //     if (res.isConfirmed) {
                    //         window.location.reload(); // 🔁 Reload only after OK is clicked
                    //         // navigate(routes.manipurlogin)
                    //     }
                    // });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function saveMedicalInfo() {
        const frmData = new FormData();
        frmData.append("medicalCondition", formData.medicalCondition);
        frmData.append("allergies", formData.allergies);
        frmData.append("allergiesDescription", formData.allergiesDescription);
        frmData.append("category", formData.category);
        frmData.append("currentMedication", formData.currentMedication);
        const injHstry = api.OnboardMedicalHistory;
        fetch(injHstry, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: frmData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                    // .then((res) => {
                    //     if (res.isConfirmed) {
                    //         window.location.reload(); // 🔁 Reload only after OK is clicked
                    //         // navigate(routes.manipurlogin)
                    //     }
                    // });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function saveInjuryInfo() {
        const frmData = new FormData();
        frmData.append("injuryType", formData.injuryType)
        frmData.append("injuryDescription", formData.injuryDescription)
        frmData.append("dateOfInjury", formData.dateOfInjury)
        frmData.append("dateOfReturnToSports", formData.dateOfReturnToSports)
        frmData.append("summaryOfTreatment", formData.summaryOfTreatment)
        frmData.append("summaryOfRecoveryProcess", formData.summaryOfRecoveryProcess)
        frmData.append("regionAffected", formData.regionAffected)
        frmData.append("diagnosis", formData.diagnosis)
        frmData.append("injurySeverity", formData.injurySeverity)
        frmData.append("mechanismOfInjury", formData.mechanismOfInjury)
        frmData.append("injuryManagementApproach", formData.injuryManagementApproach)
        frmData.append("timeLostFromTraining_Competition", formData.timeLostFromTraining_Competition)

        const injHstry = api.OnboardInjuryHistory;
        fetch(injHstry, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: frmData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                    // .then((res) => {
                    //     if (res.isConfirmed) {
                    //         window.location.reload(); // 🔁 Reload only after OK is clicked
                    //         // navigate(routes.manipurlogin)
                    //     }
                    // });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function saveSurgeryInfo() {
        const frmData = new FormData();
        frmData.append("dateOfSurgery", formData.dateOfSurgery);
        frmData.append("category", formData.category);
        frmData.append("bodyRegion", formData.bodyRegion);
        frmData.append("procedureSummary", formData.procedureSummary);
        frmData.append("complicationsIfAny", formData.complicationsIfAny);
        frmData.append("rehabilitationDuration", formData.rehabilitationDuration);
        const srgryHstry = api.OnboardSurgeryHistory;
        fetch(srgryHstry, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: frmData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                    // .then((res) => {
                    //     if (res.isConfirmed) {
                    //         window.location.reload(); // 🔁 Reload only after OK is clicked
                    //         // navigate(routes.manipurlogin)
                    //     }
                    // });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function savePhysiologicalInfo() {
        const frmData = new FormData();
        frmData.append("physiological", formData.physiological);
        const physioHstry = api.OnboardPhysiologicalHistory;
        fetch(physioHstry, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: frmData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                    // .then((res) => {
                    //     if (res.isConfirmed) {
                    //         window.location.reload(); // 🔁 Reload only after OK is clicked
                    //         // navigate(routes.manipurlogin)
                    //     }
                    // });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function proceedBasicMedicalInfo() {
        const frmData = new FormData();
        frmData.append("procced", "Yes");
        frmData.append("noHistory", 1)
        const injHstry = api.OnboardBasicMedicalHistory;
        fetch(injHstry, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: frmData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setActiveTab("Medical Profile")
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function proceedMedicalInfo() {
        const frmData = new FormData();
        frmData.append("procced", "Yes");
        frmData.append("noHistory", 1)
        const injHstry = api.OnboardMedicalHistory;
        fetch(injHstry, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: frmData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setActiveTab("Injury Profile")
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function proceedInjuryInfo() {
        const frmData = new FormData();
        frmData.append("procced", "Yes");
        frmData.append("noHistory", 1)
        const injHstry = api.OnboardInjuryHistory;
        fetch(injHstry, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: frmData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setActiveTab("Surgery Profile")
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function proceedSurgeryInfo() {
        const frmData = new FormData();
        frmData.append("procced", "Yes");
        frmData.append("noHistory", 1)
        const surgHstry = api.OnboardSurgeryHistory;
        fetch(surgHstry, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: frmData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setActiveTab("Physiological Profile")
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function handleSubmit(e) {
        e.preventDefault();
        const frmData = new FormData();
        frmData.append("physiological", formData.physiological);
        frmData.append("procced", "Yes");
        frmData.append("noHistory", 1)
        const phyHstry = api.OnboardPhysiologicalHistory;
        fetch(phyHstry, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: frmData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                        .then((res) => {
                            if (res.isConfirmed) {
                                localStorage.setItem("onboardstep", "6")
                                setTimeout(() => {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }, 100);
                            }
                        });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    return (
        <>
            <Modal
                show={openModal}
                size="xl"
                scrollable
                centered>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">Onboard</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <div className="content container" style={{ maxWidth: "1380px" }}>
                        <div className="row">
                            <div className="sortby-section">
                                <div className="sorting-info">
                                    <div className="row d-flex align-items-center">
                                        <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                            <div className="coach-court-list">
                                                <ul className="nav">
                                                    {tabData.map((tab, i) => (
                                                        <li key={i}>
                                                            <Link
                                                                to="#"
                                                                className={tab.name === activeTab ? "active" : ""}
                                                            // onClick={() => setActiveTab(tab.name)}
                                                            >
                                                                {tab.icon} {tab.name}
                                                            </Link>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                        <form ref={formRef}>
                                            <div className="tab-content">
                                                {tabData
                                                    .filter(tab => tab.name === activeTab)
                                                    .map((tab, i) => (
                                                        <div key={i}>{tab.content}</div>
                                                    ))}
                                            </div>
                                            <div className="tab-footer" style={{ marginTop: "10px" }}>
                                                <div className="d-flex justify-content-end align-items-center">
                                                    <div>
                                                        {activeTab !== "Physiological Profile" ? (
                                                            <div className="d-flex gap-2">
                                                                <button
                                                                    type="button"
                                                                    onClick={handleSave}
                                                                    className="btn btn-primary"
                                                                >
                                                                    Save &nbsp;<i className="fas fa-arrow-right" />
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    onClick={handleProceed}
                                                                    className="btn btn-secondary"
                                                                >
                                                                    Proceed &nbsp;<i className="fas fa-arrow-right" />
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <button
                                                                type="button"
                                                                onClick={handleSubmit}
                                                                className="btn btn-secondary"
                                                            >
                                                                Submit
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};

export default OnboardingTabs;